export enum DisplayVariant {
  Variant1 = "VARIANT_1",
}

export const whiteListIframeQueries = [
  "_mc",
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "code",
  "mkt1",
  "mkt2",
  "mkt3",
  "mkt4",
  "mkt5",
  "partnerref",
  "trackingcode",
  "email",
  "asset",
] as const;
